module.exports = __webpack_public_path__ + "media/icons/skrzynia-manualna-grey@2x-31a12f37.png";